<template>
  <div class="partners">
    <span id="r-add-up">
      <PartnersAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateData="updateData"
      />
    </span>
    <va-card :title="$t('partners.cards.title')">
      <div class="row">
        <div class="flex md12">
          <va-input
            v-model="name"
            :label="$t('partners.forms.nameClientLabel')"
            :placeholder="$t('partners.forms.nameClientPlaceholder')"
          />
        </div>
        <div class="flex md12 form-group mb-3">
          <va-select
            :label="$t('partners.forms.typeLabel')"
            v-model="tipo"
            textBy="name"
            keyBy='id'
            no-clear
            :placeholder="$t('partners.forms.typePlaceholder')"
            :noOptionsText="$t('partners.forms.typeNoOption')"
            maxHeight='200px'
            :options="optionsTipo"
          />
        </div>
      </div>
      <template v-if="$store.getters['authenticate/user'].role === 'user'" slot="actions">
        <va-button
          @click="open"
          icon="fa fa-plus"
          href="#r-add-up"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="partners"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template v-if="$store.getters['authenticate/user'].role === 'user'" slot="actions" slot-scope="props">
          <va-popover :message="`${$t('partners.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href="#r-add-up"
              @click="update(props.rowData)"
            />
          </va-popover>
          <va-popover :message="`${$t('tooltips.delete')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('partners.modals.message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deleting"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import PartnersAddUpdate from './PartnersAddUpdate'

const perPage = 10
export default {
  name: 'partners',
  components: {
    PartnersAddUpdate,
  },
  methods: {
    close (v) {
      this.showAdd = v
      this.updateData = null
    },
    update (data) {
      this.titleCard = 'update'
      this.updateData = data
      this.showAdd = true
    },
    open () {
      this.updateData = null
      this.showAdd = true
      this.titleCard = 'create'
    },
    showModal (data) {
      this.modalDeletar = true
      this.deleteId = data
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.partners.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_room_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId.id,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  data () {
    return {
      partners: [],
      name: '',
      optionsTipo: [
        {
          id: 3, name: 'Todos',
        },
        {
          id: 1, name: 'Parceiro',
        },
        {
          id: 2, name: 'Cliente',
        },
      ],
      tipo: {
        id: 3, name: 'Todos',
      },
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      showAdd: false,
      modalDeletar: false,
      deleteId: 0,
      titleCard: '',
      updateData: null,
      link: '',
      userId: null,
    }
  },
  apollo: {
    partners: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 2, $busca: String! = "%%", $tipo: [smallint!] = [1,2]) {
        partners: partner(limit: $perPage, offset: $page, where: {_or: [{name: {_ilike: $busca}}, {client:{firstName: {_ilike: $busca}}}], tipo: {_in: $tipo}}, order_by: {id: asc}) {
          id
          name
          code
          active
          user {
            id
            name
          }
          client {
            id
            firstName
          }
        }
      }
      `,
      variables () {
        return {
          perPage,
          page: 0,
          busca: this.nameSearch,
          tipo: this.typeSearch,
        }
      },
    },
    pages: gql`
    query MyQuery($busca: String! = "%%", $tipo: [smallint!] = [1,2]) {
      pages: partner_aggregate(where: {_or: [{name: {_ilike: $busca}}, {client:{firstName: {_ilike: $busca}}}], tipo: {_in: $tipo}}) {
        aggregate {
          count
        }
      }
    }
    `,
    variables () {
      return {
        busca: this.nameSearch,
        tipo: this.typeSearch,
      }
    },
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    nameSearch () {
      return '%' + this.name.trim() + '%'
    },
    typeSearch () {
      return this.tipo.id === 3 ? [1, 2] : [this.tipo.id]
    },
    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'name',
        title: this.$t('partners.headings.name'),
        width: '15%',
      }, {
        name: 'code',
        title: this.$t('partners.headings.code'),
        width: '15%',
      }, {
        name: '',
        title: this.$t('partners.headings.link'),
        width: '15%',
        callback (value) {
          const link = process.env.VUE_APP_LINK
          return value.active ? link + '/clube?ref=' + value.code : ''
          // return value.active ? '<a href="' + this.link + '?ref=' + value.code + '"></a>' : ''
        },
      },
      {
        name: 'active',
        title: this.$t('partners.headings.active'),
        width: '10%',
        callback (value) {
          return value ? 'Sim' : 'Não'
        },
      }, {
        name: 'user',
        title: this.$t('partners.headings.user'),
        width: '15%',
        callback (value) {
          return value !== null ? value.id + ' - ' + value.name : ''
        },
      }, {
        name: 'client',
        title: this.$t('partners.headings.client'),
        width: '15%',
        callback (value) {
          return value !== null ? value.id + ' - ' + value.firstName : ''
        },
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('partners')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.partners.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
